<template>

     <template v-if="currentSchoolyear && adminSchoolyear">

        <el-card shadow="hover">
            <el-row align="middle">
                <el-col :span="12">
                    <div class="text-left">
                        <h3>{{ $t('levelsList') }}</h3>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="text-right">
                        <el-button size="default" @click="addItem()">
                            {{ $t('add') }}
                        </el-button>
                    </div>
                </el-col>
            </el-row>

            <el-divider></el-divider>

            <el-table :data="pagedTableData" :empty-text="$t('noData')" style="width: 100%" border stripe v-loading="isLoading">

                <el-table-column type="index" :index="indexMethod"> </el-table-column>
                <el-table-column sortable :label="$t('name')" prop="name"> </el-table-column>
                <el-table-column sortable :label="$t('type')" prop="type">
                    <template #default="scope">
                        {{ getLevelTypeLabel(scope.row.type) }}
                    </template>
                </el-table-column>
                <el-table-column sortable :label="$t('position')" prop="idx">
                    <template #default="scope">
                        <el-tag>{{scope.row.idx}}</el-tag>
                    </template>
                </el-table-column>

                <el-table-column align="right">

                    <template #header>
                        <el-input v-model="search" size="small" :placeholder="$t('search')" />
                    </template>

                    <template #default="scope">
                        <el-button size="small" @click="editItem(scope.$index, scope.row)">
                            {{ $t('edit') }}
                        </el-button>
                        <el-button size="small" type="danger" @click="deleteItem(scope.$index, scope.row)">
                            {{ $t('delete') }}
                        </el-button>
                    </template>

                </el-table-column>

            </el-table>

            <div style="text-align: center; margin-top: 20px">

                <el-pagination
                    background
                    layout="prev, pager, next"
                    @current-change="setPage"
                    :hide-on-single-page="true"
                    :page-size="pageSize"
                    :total="total">
                </el-pagination>

            </div>
        </el-card>

        <el-dialog :title="$t('addLevel')" v-model="addDialog" width="65%">

            <el-form :inline="true" :model="addLevel" :rules="rules" :ref="addLevelForm">

                <el-form-item prop="name" :label="$t('name')">
                    <el-input
                        :placeholder="$t('name')"
                        v-model="addLevel.name"/>
                </el-form-item>

                <el-form-item prop="type" :label="$t('type')">
                    <el-select
                        v-model="addLevel.type"
                        :placeholder="$t('select')"
                        filterable
                        :no-data-text="$t('noData')"
                        :no-match-text="$t('noMatchingData')">
                        <el-option
                            v-for="item in levelTypesList"
                            :key="item.id"
                            :value="item.id"
                            :label="item.label">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item prop="idx" :label="$t('position')">
                    <el-input-number v-model="addLevel.idx" :min="1"/>
                </el-form-item>

            </el-form>

            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="cancelForm(addLevelForm)">{{ $t('cancel') }}</el-button>
                    <el-button type="primary" @click="submitForm(addLevelForm)">{{ $t('confirm') }}</el-button>
                </span>
            </template>

        </el-dialog>

        <el-dialog :title="$t('editLevel')" v-model="editDialog" width="65%">

            <el-form :inline="true" :model="editLevel" :rules="rules" :ref="editLevelForm">

                <el-form-item prop="name" :label="$t('name')">
                    <el-input
                        :placeholder="$t('name')"
                        v-model="editLevel.name"/>
                </el-form-item>

                <el-form-item prop="type" :label="$t('type')">
                    <el-select
                        v-model="editLevel.type"
                        :placeholder="$t('select')"
                        filterable
                        :no-data-text="$t('noData')"
                        :no-match-text="$t('noMatchingData')">
                        <el-option
                            v-for="item in levelTypesList"
                            :key="item.id"
                            :value="item.id"
                            :label="item.label">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item prop="idx" :label="$t('position')">
                    <el-input-number v-model="editLevel.idx" :min="1"/>
                </el-form-item>

            </el-form>

            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="cancelForm(editLevelForm)">{{ $t('cancel') }}</el-button>
                    <el-button type="primary" @click="submitForm(editLevelForm)">{{ $t('confirm') }}</el-button>
                </span>
            </template>

        </el-dialog>

     </template>

     <el-alert :title="$t('noCurrentSchoolyearWarning')" type="warning" v-else/>

</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import fr from 'element-plus/lib/locale/lang/fr'

import { LevelTypes } from '@/utils/enums'

import accessManager from '@/mixins/access-manager'

export default {
    name: 'Levels',
    mixins: [accessManager],
    data() {
      return {
        levelTypesList: [],
        primaryColor: process.env.VUE_APP_PRIMARY_COLOR,
        editLevel: {
            name: '',
            type: '',
            idx: 1
        },
        addLevel: {
            name: '',
            type: '',
            idx: 1
        },
        rules: {
            name: [
                {
                    required: true,
                    message: this.$t('fieldRequired'),
                    trigger: 'blur',
                }
            ],
            type: [
                {
                    required: true,
                    message: this.$t('fieldRequired'),
                    trigger: 'blur',
                }
            ],
            idx: [
                {
                    required: true,
                    message: this.$t('fieldRequired'),
                    trigger: 'blur',
                }
            ]
        },
        editLevelForm: 'editLevelForm',
        addLevelForm: 'addLevelForm',
        currentEditItem: null,
        editDialog: false,
        isLoading: false,
        addDialog: false,
        tableData: [],
        pageSize: 6,
        locale: fr,
        search: '',
        total: 0,
        page: 1
      }
    },
    created() {

      this.fetchLevels()

      var self = this

      this.$_.forIn(LevelTypes, function(value, key) {

          self.levelTypesList.push(value)

      })

    },
    computed:{
      ...mapState({
        userData: state => state.session.userData
      }),
      ...mapGetters({
        getSettingValue: 'settings/getSettingValue'
      }),
      pagedTableData() {

        this.total = this.searching.length

        return this.searching.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page)

      },
      searching() {

        if (!this.search) {
            this.total = this.tableData.length
            return this.tableData
        }

        this.page = 1

        return this.tableData.filter(data => data.name.toLowerCase().includes(this.search.toLowerCase()))

      }
    },
    methods: {
      ...mapActions({
         fetchLevelsDB: 'levels/fetchLevelsDB',
      }),
      setPage (val) {

         this.page = val

      },
      indexMethod(index) {

         return index + ((this.page - 1) * this.pageSize) + 1

      },
      getLevelTypeLabel(id){

          let levelType = this.levelTypesList.find(lt => lt.id == id)

          return levelType ? levelType.label : ''

      },
      async fetchLevels(){

        if (!this.adminSchoolyear) return

        this.isLoading = true

        let resp = await this.fetchLevelsDB({
            action: 'getLevels',
            params: {
                schoolyear: this.adminSchoolyear
            }
        })

        if (resp.success){

            if (resp.data) this.tableData = resp.data

        }else{

            this.$message.error(this.$t('anErrorOccured'))

        }

        this.isLoading = false

      },
      addItem(){

           if (this.lockedData){
                this.$message.warning(this.$t('lockedData'))

                return
           }

           this.addDialog = true

      },
      async editItem(index, item){

            if (this.lockedData){
                this.$message.warning(this.$t('lockedData'))

                return
            }

            this.currentEditItem = item

            this.editLevel.name = item.name
            this.editLevel.idx = parseInt(item.idx)
            this.editLevel.type = parseInt(item.type)

            this.editDialog = true

      },
      deleteItem(index, item){

            if (this.lockedData){
                this.$message.warning(this.$t('lockedData'))

                return
            }

            this.$confirm(this.$t('deleteLevelQuestion'), this.$t('delete'), {
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('cancel'),
                type: 'warning',
            })
            .then(async () => {

                let task = await this.fetchLevelsDB({
                    action: 'deleteLevel',
                    params: {
                        id: item.id
                    }
                })

                if (task.success){

                    this.$message.success(this.$t('success'))
                    this.fetchLevels()

                }else{

                    this.$message.error(this.$t('anErrorOccured'))

                }

            })
            .catch(() => {

            })

      },
      submitForm(ref){

            this.$refs[ref].validate(async (valid) => {
                if (valid) {

                    if (ref === this.addLevelForm){

                        let task = await this.fetchLevelsDB({
                            action: 'addLevel',
                            params: {
                                idx: this.addLevel.idx,
                                name: this.addLevel.name,
                                type: this.addLevel.type,
                                schoolyear: this.adminSchoolyear
                            }
                        })

                        if (task.success) this.$message.success(this.$t('success'))
                        else this.$message.error(this.$t('anErrorOccured'))

                    }else{

                        let newData = {}

                        if (this.currentEditItem.idx !== this.editLevel.idx) {
                            newData['idx'] = this.editLevel.idx
                        }

                        if (this.currentEditItem.name !== this.editLevel.name) {
                            newData['name'] = this.editLevel.name
                        }

                        if (this.currentEditItem.type !== this.editLevel.type) {
                            newData['type'] = this.editLevel.type
                        }

                        if (!this.$_.isEmpty(newData)){
                            let task = await this.fetchLevelsDB({
                                action: 'editLevel',
                                params: {
                                    id: this.currentEditItem.id,
                                    data: newData
                                }
                            })

                            if (task.success) this.$message.success(this.$t('success'))
                            else this.$message.error(this.$t('anErrorOccured'))
                        }

                    }

                    this.cancelForm(ref)
                    this.fetchLevels()

                } else {
                    return false
                }
            })

      },
      cancelForm(ref){

            this.$refs[ref].resetFields()

            if (ref === this.addLevelForm) this.addDialog = false
            else this.editDialog = false

      }
    },
}
</script>